import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑" className="flex items-center flex-wrap gap-2 text-xs md:text-sm text-foreground-500">
      {items.map((item, i) => (
        <span key={item.label} className="flex items-center gap-2">
          {item.to ? (
            <Link to={item.to} className="hover:text-accent-600 transition-colors">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
          {i < items.length - 1 && <i className="ri-arrow-right-s-line text-foreground-300"></i>}
        </span>
      ))}
    </nav>
  );
}